import { graphql } from '../../graphql';

export const getTownships = graphql(`
  query Townships($regionId: ID!) {
    townships(regionId: $regionId) {
      id
      name
      latitude
      longitude
    }
  }
`);
